import type { LotMarket, PriceGuideRegion } from '@brickloop/core/schemas';
import { useQuery } from '@tanstack/react-query';
import { api, type LotRow } from './api';

/** An inventory row as the API now returns it: the lot plus the cached BrickLink market figures, when there are any. */
export type MarketLotRow = LotRow & { market: LotMarket | null };

/** How the background refresh of BrickLink's price guide is getting on. Mirrors what the API returns. */
export interface MarketStatus {
  region: PriceGuideRegion;
  lotsInStock: number;
  /** Tracked parts that have no stock left. They are still watched, to answer whether to buy them back. */
  soldOut: number;
  /** Every part being watched: in stock plus sold out. */
  tracked: number;
  withFigures: number;
  unavailable: number;
  waiting: number;
  due: number;
  stale: number;
  oldestFetchedAt: string | null;
  newestFetchedAt: string | null;
  lastRun: { at: string; ok: boolean; detail: unknown } | null;
  nightsToCatchUp: number;
  requestsToday: { used: number; cap: number };
  reserve: number;
  runLimit: number;
}

export const useMarketStatus = () =>
  useQuery({
    queryKey: ['market-status'],
    queryFn: () => api<MarketStatus>('/api/v1/market/status'),
    staleTime: 60_000,
  });
